var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-capitalize",attrs:{"color":_vm.status.color,"small":!_vm.large,"large":_vm.large,"label":"","outlined":""}},[(_vm.status.icon)?_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.status.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.status.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }